import type { ComponentType } from 'react'
import type { LoadableComponent } from '@loadable/component'

export interface RouteConfig {
  path: string
  Component: LoadableComponent<ComponentType<any>>
  exact?: boolean
}

export default function getRoutes(): RouteConfig[] {
  const routes: RouteConfig[] = []

  return routes
}
